import { Escalation, PhaseDateTime } from '../../models/phases';
import { Phases } from '../../models/phases';
import { SelectItems } from '../../../../../shared/Models/SelectItems';
import { PhaseService } from '../../services/phase.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbComponentStatus, NbDialogRef } from '@nebular/theme';
import { FormMAsterService } from '../../../../../DynamicFormsModule/formsMaster/services/formMaster.service';

@Component({
  selector: 'app-edit-phase',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})
export class EditPhaseComponent implements OnInit {
  requiredCreateDate: SelectItems[] = [];
  phase: Phases = {} as Phases;
  users: any[];
  legals: any[];
  userSectionFlg: boolean;
  legalSectionFlg: boolean;
  userEscalationSectionFlg: boolean;
  escalDays: number;
  escaleHours: number;
  dynmicFormList: any[] = [];
  finishLoading: boolean;
  formsfinishLoading: boolean;
  phaseId: number;
  constructor(
    private service: PhaseService,
    private route: ActivatedRoute,
    private toastrService: NbToastrService,
    private router: Router,
    private dFormService: FormMAsterService,
    private ref: NbDialogRef<EditPhaseComponent>
  ) {}
  timeType = [
    { name: 'شهر', id: 1 },
    { name: 'يوم', id: 2 },
    { name: 'ساعه', id: 3 },
  ];
  assignUserTypes = [
    { name: 'بالصفة الشخصية', id: 1 },
    { name: 'بالوظيفة', id: 2 },
    // { name: 'User Group', id: 3 },
    // { name: 'Unit', id: 4 },
    { name: 'مقدم الطلب', id: 5 },
  ];
  escalationMethods = [
    { name: 'One Level Up', id: 1 },
    { name: 'Multi Level Up', id: 2 },
    { name: 'Personal', id: 3 },
  ];
  ngOnInit() { 
      this.router.events.subscribe(()=>{
      this.ref.close('false');
     });
    //  this.loadRequiredCreateDate();
    const phaseId = this.phaseId;
    this.service.getUpdate(phaseId).subscribe((res) => {
      this.phase = res.entity;
      console.log(this.phase);

      if (this.phase.escalationVm == null) {
        this.phase.escalationVm = {} as Escalation;
      }
      if (this.phase.normal == null) {
        this.phase.normal = { flgDateType: 0, timeValue: 0 } as PhaseDateTime;
      }
      if (this.phase.optimal == null) {
        this.phase.optimal = { flgDateType: 0, timeValue: 0 } as PhaseDateTime;
      }
      this.finishLoading = true;
      this.dropdownChange(this.phase.flgAssignType);
    });

    this.dFormService.getCreateNew().subscribe((res) => {
      this.dynmicFormList = res[0].values;
      this.formsfinishLoading = true;
    })
    console.log(this.phase.flgAssignType);
  }
  loadRequiredCreateDate() {
    // this.service.getUpdate().subscribe((res) => {
    //   this.requiredCreateDate = res;
    // });
  }
DisapledfirstStepButton() : boolean
{
  if(!this.phase.name || !this.phase.sequence)
  {
  return true;
  }
  return false;
}
DisapledSecondStepButton() : boolean
{
  if(!this.phase.normal.timeValue 
    ||!this.phase.optimal.timeValue
  )
  {
  return true;
  }
  return false;
}
DisapledFinalStepButton() : boolean
{
  if(this.phase.escalationVm === null || 
     this.phase.escalationVm.flgPeriodRef === null || 
     this.phase.escalationVm.flgPeriodRef === 0)
  {
  return true;
  }
  return false;
}
  addNewPhase() {
    // this.service.post(this.phase).subscribe(res => {});
  }
  dropdownChange($event) {
    console.log($event);

    switch ($event) {
      case 1:
        this.initalize();
        this.userSectionFlg = true;
        this.service.getPhaseUsers(1).subscribe((res) => {
          this.users = res;
        });
        // this.users = [{ name: 'ali', id: 2 }];
        break;
      case 2:
        this.initalize();
        this.legalSectionFlg = true;
        this.service.getPhaseUsers(2).subscribe((res) => {
          this.legals = res;
        });
        break;
      default:
        this.initalize();
    }
  }
  escalationChange($event) {
    switch ($event) {
      case 3:
        if (this.users == null || this.users.length === 0) {
          this.service.getPhaseUsers(1).subscribe((res) => {
            this.users = res;
          });
        }
        this.userEscalationSectionFlg = true;
        break;
      default:
        this.userEscalationSectionFlg = false;
    }
  }
numbersOnly(event: any ) {
  const input = event.target as HTMLInputElement;
  input.value = input.value.replace(/[^0-9]/g, '');
}
  initalize() {
    this.userSectionFlg = false;
    this.legalSectionFlg = false;
  }
  save() {
    // console.log(this.phase);
    // this.phase.FlgAssignRef = 1;
    // this.phase.FlgAssignType = 1;
    // this.phase.escalationVm.flgEscaleToType = 1;
    // this.phase.escalationVm.escaleToRef = '1';
    // this.phase.escalationVm.flgPeriodRef = 3;
    // this.phase.escalationVm.flgPeriodType = 3;
    this.service.put(this.phase.id, this.phase).subscribe((res) => {
      const position = 'bottom-right';
      this.showToast(position, `add phase ${this.phase.name} successfully`, 'success');
      // this.phase = {} as Phases;
      // console.log(res);
    });
  }
  showToast(position, message, status: NbComponentStatus) {
    this.toastrService.show(message, '', { position, status });
  }
  back() {
    const route = ['workflow'];
    this.router.navigate(route);
  }

  close() {
    this.ref.close();
  }
}
